// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prof-split {
  display: grid;
  grid-template-columns: 30% 70%;
  gap: 56px;
  align-items: start;
}

.prof-text {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.prof-buttons {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 24px;
}

.prof-buttons .btn {
  width: 100%;
  text-align: center;
  padding: 16px 28px;
  font-size: 15px;
  border-radius: 10px;
  font-weight: 700;
  transition: all 0.3s ease;
  cursor: pointer;
}

.prof-buttons .btn-orange {
  background: #EE5B43;
  color: #ffffff;
  border: 2px solid #EE5B43;
  box-shadow: 0 4px 15px rgba(238, 91, 67, 0.25);
}

.prof-buttons .btn-orange:hover {
  background: #e14f36;
  border-color: #e14f36;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(238, 91, 67, 0.35);
}

.prof-buttons .btn-primary {
  background: #ffffff;
  color: #EE5B43;
  border: 2px solid #EE5B43;
}

.prof-buttons .btn-primary:hover {
  background: #fff5f3;
  color: #EE5B43;
  border-color: #EE5B43;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(238, 91, 67, 0.15);
}

.prof-text .eyebrow {
  margin-bottom: 20px;
  color: #EE5B43;
  font-weight: 600;
}

.prof-h2 {
  font-size: 25px;
  font-weight: 700;
  line-height: 1.25;
  margin: 0 0 8px;
  color: var(--ink);
}

.prof-h2-accent {
  display: block;
  color: #EE5B43;
}

.prof-rule {
  width: 40px;
  height: 3px;
  background: #EE5B43;
  border-radius: 2px;
  margin: 20px 0 28px;
}

.prof-checklist {
  margin: 0 0 32px;
}

.prof-checklist p {
  font-size: 15.5px;
  line-height: 1.8;
  color: var(--ink);
  margin: 0;
}

.prof-checklist p:first-of-type {
  margin-bottom: 1.5rem;
}

.prof-checklist p strong {
  font-weight: 700;
}

.prof-footnote {
  font-size: 12.5px;
  font-style: italic;
  line-height: 1.7;
  color: var(--mut);
  margin-top: 14px !important;
}

.prof-cta-link {
  display: block;
  width: 100%;
  text-decoration: none;
}

.prof-cta-link .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  line-height: 1.4;
  white-space: normal;
}

.prof-visual {
  display: flex;
  align-items: flex-start;
}

@media (max-width: 820px) {
  .prof-split {
    grid-template-columns: 1fr;
    gap: 32px;
  }
}

@media (max-width: 768px) {
  .prof-h2 {
    font-size: 22px;
  }

  .prof-buttons .btn {
    padding: 14px 20px;
    font-size: 14px;
  }

  .prof-cta-link .btn {
    width: 100%;
  }

  .prof-text {
    align-items: center;
    text-align: center;
  }

  .prof-text .eyebrow {
    text-align: center;
  }

  .prof-rule {
    margin-left: auto;
    margin-right: auto;
  }

  .prof-checklist {
    text-align: center;
  }
}

/* ───────── Responsive : mobile, contenu centré ───────── */
@media (max-width: 480px) {
  .prof-text {
    align-items: center;
    text-align: center;
  }

  .prof-text .eyebrow {
    text-align: center;
  }

  .prof-rule {
    margin-left: auto;
    margin-right: auto;
  }

  .prof-checklist {
    text-align: center;
  }
}

@media (max-width: 360px) {
  .prof-h2 {
    font-size: 20px;
  }

  .prof-checklist p {
    font-size: 14px;
  }

  .prof-footnote {
    font-size: 11.5px;
  }
}

/* ───────── Réduction de l'espace entre #professionnels et #alertes ───────── */
#professionnels {
  padding-bottom: 48px;
}

@media (max-width: 1024px) {
  #professionnels {
    padding-bottom: 36px;
  }
}

@media (max-width: 768px) {
  #professionnels {
    padding-bottom: 28px;
  }
}

@media (max-width: 480px) {
  #professionnels {
    padding-bottom: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/ProfessionalsSection/ProfessionalsSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,gFAAgF;AAChF;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".prof-split {\n  display: grid;\n  grid-template-columns: 30% 70%;\n  gap: 56px;\n  align-items: start;\n}\n\n.prof-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.prof-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-top: 24px;\n}\n\n.prof-buttons .btn {\n  width: 100%;\n  text-align: center;\n  padding: 16px 28px;\n  font-size: 15px;\n  border-radius: 10px;\n  font-weight: 700;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.prof-buttons .btn-orange {\n  background: #EE5B43;\n  color: #ffffff;\n  border: 2px solid #EE5B43;\n  box-shadow: 0 4px 15px rgba(238, 91, 67, 0.25);\n}\n\n.prof-buttons .btn-orange:hover {\n  background: #e14f36;\n  border-color: #e14f36;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(238, 91, 67, 0.35);\n}\n\n.prof-buttons .btn-primary {\n  background: #ffffff;\n  color: #EE5B43;\n  border: 2px solid #EE5B43;\n}\n\n.prof-buttons .btn-primary:hover {\n  background: #fff5f3;\n  color: #EE5B43;\n  border-color: #EE5B43;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(238, 91, 67, 0.15);\n}\n\n.prof-text .eyebrow {\n  margin-bottom: 20px;\n  color: #EE5B43;\n  font-weight: 600;\n}\n\n.prof-h2 {\n  font-size: 25px;\n  font-weight: 700;\n  line-height: 1.25;\n  margin: 0 0 8px;\n  color: var(--ink);\n}\n\n.prof-h2-accent {\n  display: block;\n  color: #EE5B43;\n}\n\n.prof-rule {\n  width: 40px;\n  height: 3px;\n  background: #EE5B43;\n  border-radius: 2px;\n  margin: 20px 0 28px;\n}\n\n.prof-checklist {\n  margin: 0 0 32px;\n}\n\n.prof-checklist p {\n  font-size: 15.5px;\n  line-height: 1.8;\n  color: var(--ink);\n  margin: 0;\n}\n\n.prof-checklist p:first-of-type {\n  margin-bottom: 1.5rem;\n}\n\n.prof-checklist p strong {\n  font-weight: 700;\n}\n\n.prof-footnote {\n  font-size: 12.5px;\n  font-style: italic;\n  line-height: 1.7;\n  color: var(--mut);\n  margin-top: 14px !important;\n}\n\n.prof-cta-link {\n  display: block;\n  width: 100%;\n  text-decoration: none;\n}\n\n.prof-cta-link .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  line-height: 1.4;\n  white-space: normal;\n}\n\n.prof-visual {\n  display: flex;\n  align-items: flex-start;\n}\n\n@media (max-width: 820px) {\n  .prof-split {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n}\n\n@media (max-width: 768px) {\n  .prof-h2 {\n    font-size: 22px;\n  }\n\n  .prof-buttons .btn {\n    padding: 14px 20px;\n    font-size: 14px;\n  }\n\n  .prof-cta-link .btn {\n    width: 100%;\n  }\n\n  .prof-text {\n    align-items: center;\n    text-align: center;\n  }\n\n  .prof-text .eyebrow {\n    text-align: center;\n  }\n\n  .prof-rule {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .prof-checklist {\n    text-align: center;\n  }\n}\n\n/* ───────── Responsive : mobile, contenu centré ───────── */\n@media (max-width: 480px) {\n  .prof-text {\n    align-items: center;\n    text-align: center;\n  }\n\n  .prof-text .eyebrow {\n    text-align: center;\n  }\n\n  .prof-rule {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .prof-checklist {\n    text-align: center;\n  }\n}\n\n@media (max-width: 360px) {\n  .prof-h2 {\n    font-size: 20px;\n  }\n\n  .prof-checklist p {\n    font-size: 14px;\n  }\n\n  .prof-footnote {\n    font-size: 11.5px;\n  }\n}\n\n/* ───────── Réduction de l'espace entre #professionnels et #alertes ───────── */\n#professionnels {\n  padding-bottom: 48px;\n}\n\n@media (max-width: 1024px) {\n  #professionnels {\n    padding-bottom: 36px;\n  }\n}\n\n@media (max-width: 768px) {\n  #professionnels {\n    padding-bottom: 28px;\n  }\n}\n\n@media (max-width: 480px) {\n  #professionnels {\n    padding-bottom: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
